import * as angular from 'angular';

import { ComponentDefinition, Group, RefreshClickData } from '../../models';
import { DigitalSignatureWidget } from './digitalSignature.widget';
import { IApprovalResultsService, IGroupSelectionService, IDateRangeService } from '../../services';
import { refreshClick, groupSelected } from '../../common';

class DigitalSignatureController implements angular.IComponentController {
    item: DigitalSignatureWidget;
    isLoading: boolean;
    imageStyle: any;
    isApproved: boolean;
    userName: string;

    readonly selectedGroup: Group;

    static $inject = ['$scope', 'approvalResultsService', 'groupSelectionService', 'dateRangeService'];

    constructor(
        private _$scope: angular.IScope,
        private _approvalResultsService: IApprovalResultsService,
        private _groupSelectionService: IGroupSelectionService,
        private _dateRangeService: IDateRangeService
    ) {
    }

    $onInit() {
        this._$scope.$on(refreshClick, (event, data: RefreshClickData) => {
            this.refresh();
        });
        this._$scope.$on(groupSelected, () => {
            this.refresh();
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedGroup'] && !!this.selectedGroup && changesObj['selectedGroup'].currentValue !== changesObj['selectedGroup'].previousValue) {
            this.refresh();
        }
    }

    private refresh() {
        this.isLoading = true;
        const selectedGroup = this.selectedGroup || this._groupSelectionService.selectedGroup();
        if (selectedGroup && this._dateRangeService.initialized()) {
            const beginDate = this._dateRangeService.beginDate() as string;
            const endDate = this._dateRangeService.endDate() as string;
            this._approvalResultsService.get(selectedGroup.guid, beginDate, endDate)
                .then(data => {
                    this.imageStyle = data.signature
                        ? { 'background-image': `url('data:image/false;base64,${data.signature}')` }
                        : null;
                    this.isApproved = data.isApproved;
                    this.userName = data.userName;
                })
                .finally(() => this.isLoading = false);
        } else {
            this.isLoading = false;
        }
    }
}

export const wtDigitalSignature: ComponentDefinition = {
    componentId: 'wtDigitalSignature',
    controller: DigitalSignatureController,
    template: require('./digitalSignature.component.html'),
    controllerAs: 'vm',
    bindings: {
        boundData: '<',
        item: '<',
        selectedGroup: '<?'
    }
};
